<template>
    <div>
        <div
            class="modal fade"
            id="substituteModal"
            tabindex="-1"
            aria-labelledby="substituteModalLabel"
            aria-hidden="true"
            ref="modalEl"
        >
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="substituteModalLabel">
                            Substitutes for {{ partLabel }}
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>

                    <div class="modal-body">
                        <SubstitutesTreeView
                            :root-part="activePartCode"
                            :part-label="partLabel"
                            :enable-remove-request="true"
                            @select-substitute="onSelectFromTree"
                            @remove-request="onRemoveRequest"
                        />
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Modal } from 'bootstrap'
    import { toast } from 'vue3-toastify'
    import SubstitutesTreeView from '@/components/substitutes/SubstitutesTreeView.vue'
    import { mapStores } from 'pinia'
    import { useSubstitutesStore } from '@/stores/substitutesStore'

    export default {
        name: 'SubstituteModal',
        components: { SubstitutesTreeView },
        props: {
            partLabel: { type: String, default: '' },
        },
        data() {
            return {
                bsModal: null,
                activePartCode: '',
                onModalShow: null,
                onModalHide: null,
            }
        },
        emits: ['select-substitute', 'opened', 'closed', 'select-unlink-substitute'],
        computed: {
            ...mapStores(useSubstitutesStore),
        },
        mounted() {
            this.bsModal = new Modal(this.$refs.modalEl)

            this.onModalShow = () => this.$emit('opened')
            this.onModalHide = () => this.$emit('closed')

            this.$refs.modalEl.addEventListener('shown.bs.modal', this.onModalShow)
            this.$refs.modalEl.addEventListener('hidden.bs.modal', this.onModalHide)
        },
        beforeUnmount() {
            if (this.$refs.modalEl) {
                if (this.onModalShow) {
                    this.$refs.modalEl.removeEventListener('shown.bs.modal', this.onModalShow)
                }
                if (this.onModalHide) {
                    this.$refs.modalEl.removeEventListener('hidden.bs.modal', this.onModalHide)
                }
            }
        },
        methods: {
            open(partCode) {
                this.applyModalState(partCode)
                this.bsModal.show()
            },
            sync(partCode) {
                this.applyModalState(partCode)
            },
            applyModalState(partCode) {
                this.activePartCode = partCode
            },
            close() {
                if (this.bsModal) this.bsModal.hide()
            },
            emitSelect(item) {
                this.$emit('select-substitute', item)
                const selectedCode = item?.code || item?.name || ''
                this.substitutesStore.setSelectedSubstituteOnModal(selectedCode)
            },
            showToast(message, type) {
                toast(message, {
                    type,
                    pauseOnFocusLoss: false,
                })
            },
            onSelectFromTree(item) {
                if (!item) return
                this.emitSelect(item)
                this.showToast('Highlighting the selected part!', 'default')
                this.close()
            },
            onRemoveRequest(payload) {
                this.$emit('select-unlink-substitute', payload)
            },
        },
    }
</script>

<style scoped lang="scss">
    #substituteModal {
        z-index: 9999 !important;
        .modal-dialog {
            width: calc(100% - 1rem);
            --bs-modal-width: 80vw;
            .modal-content {
                width: auto;
                min-width: min(400px, 100%);
            }
        }
    }
</style>
